export enum PRESENTERS_TYPES {
  Homepage = 'Home', // todo - set correct presenter
  Account = 'Account', // todo - set correct presenter
  Purchases = 'Purchases', // todo - set correct presenter //??
  LoyaltyClub = '\\loyaltyProgram\\LoyaltyProgram',
}
